










































































































import Vue from 'vue'
import TeammateCard from '@/components/TeammateCard.vue'
import User from '@/types/User.interface'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { TeammateCard },
    data: () => ({
        loading: false,
        // Default filter option that is automatically chosen
        initialDate: 'Last 30 Days',
        // Choices user is allowed to make in the v-select
        timeSelector: [
            'Last 30 Days',
            'Last Month',
            'Last Year',
            'This Month',
            'This Year to Date',
        ]
    }),
    async mounted() {
        //  Check if we have metrics already
        const metrics = this.usersMetrics && this.tenantMetrics

        //  If already set, don't refresh
        if (metrics) return

        //  Start loading
        this.loading = true

        //  Get our metrics
        await this.$store.dispatch('usersMetrics', this.initialDate)
        await this.$store.dispatch('tenantMetrics', this.initialDate)

        //  Stop loading
        this.loading = false
    },
    computed: {
        ...mapGetters([
            'isApp',
            'tenant',
            'tenantMetrics',
            'user',
            'usersMetrics'
        ]),
        homeTiles() {
            //  Grab all of our metric values
            const rec = this.tenantMetrics?.received || 0
            const broadcasts = this.tenantMetrics?.broadcasts || 0
            const reach = this.tenantMetrics?.reached || 0
            const reply = this.tenantMetrics?.replyRate || 0

            return [
                {
                    title: this.tenant.company_name,
                    btn:
                        this.$vuetify.breakpoint.xsOnly || this.isApp
                            ? null
                            : {
                                  text: 'View Reporting',
                                  icon: 'bi-arrow-right-circle-fill',
                                  callback: () => this.$router.push('/messages')
                              },
                    columns: [
                        {
                            value: rec,
                            display: 'Messages Received'
                        },
                        {
                            value: broadcasts,
                            display: 'Broadcasts Sent'
                        },
                        {
                            value: reach,
                            display: 'Contacts Reached'
                        },
                        {
                            value: reply,
                            display: 'Reply Rate'
                        }
                    ]
                }
            ]
        },
        users(): User[] {
            //  Grab our users
            const users = this.$store.getters.users

            //  If users are null, return null
            if (!users) return null

            //  Else, grab our metrics
            const metrics = this.usersMetrics

            //  If our metrics are null then return null
            if (!metrics) return null

            //  Else, assign these metrics to our users
            users.forEach((x: User) => {
                Object.assign(x, metrics[x.id])
            })

            return users
        },
        widthStyle(): string {
            //  Grab our breakpoint
            const bp = this.$vuetify.breakpoint.name

            //  Depending on our current breakpoint we have a different style for width
            const style =
                {
                    sm: 'width: 600px;',
                    md: 'width: 800px;',
                    lg: 'width: 800px;',
                    xl: 'width: 800px;'
                }[bp] || ''

            //  Return our style
            return style
        }
    },
    methods: {
        async setDateTime(dateTime: string): Promise<void> {
            //  We just pass the user's choice here and handle the datetime math on the backend as it's significantly easier with Carbon
            const payload = {
                "date": dateTime
            }

            //  Start loading
            this.loading = true
            
            //  Send request to update our metrics based on date filter
            await this.$store.dispatch('usersMetrics', payload)
            await this.$store.dispatch('tenantMetrics', payload)

            //  Stop loading
            this.loading = false

            return
        },
    }
})
